import { Alert, Grid } from "@mui/material";

import Libelle from "../../../../_i18n/fr.json";
import InputCheckbox from "../../../../components/inputCheckbox/InputCheckbox";
import { useHabilitationsAdb } from "./selectors";
import Snack from "../../../../components/Snack";

export interface Props {
  idAdb: number;
  parcoursLocataire?: boolean;
}
const Habilitations = ({ idAdb, parcoursLocataire }: Props) => {
  const {
    parcoursLocataireChecked,
    loadingPatchAdb,
    errorPatchAdb,
    handleChangeParcoursLocataire,
    successPatchAdb,
    resetPatchAdb,
  } = useHabilitationsAdb(idAdb, parcoursLocataire);

  return (
    <Grid item>
      <h3>Habilitations</h3>

      <InputCheckbox
        input={{
          value: parcoursLocataireChecked,
          name: "parcoursLocataire",
          onBlur: () => {},
          onChange: (ev: any) => handleChangeParcoursLocataire(ev),
          onFocus: () => {},
        }}
        meta={{
          initial: parcoursLocataireChecked,
        }}
        id="parcoursLocataire"
        name="parcoursLocataire"
        value={parcoursLocataireChecked}
        label="Parcours candidat locataire"
        disabled={loadingPatchAdb}
      />

      {errorPatchAdb && (
        <Alert color="error">
          {errorPatchAdb.response?.data?.message || Libelle.erreurs.generique}
        </Alert>
      )}

      <Snack
        onClose={resetPatchAdb}
        variant="success"
        message="Le paramétrage a bien été enregistré"
        open={successPatchAdb}
      />
    </Grid>
  );
};

export default Habilitations;
